import { useI18n } from 'vue-i18n'
import type { ICheckbox, ICheckboxEvent } from '@/components/CheckboxController/CheckboxController.types'
import { useMultisportPartnersStore } from '@/domains/partners/multisport/store/useMultiSportPartnersStore'
import { AGREEMENT_KEYS } from '@/domains/partners/multisport/const/AgreementKeys.const'

export const useAgreements = () => {
  const { t } = useI18n()
  const { form } = useMultisportPartnersStore()

  const checkboxesMain = computed<ICheckbox>(() => (
    {
      id: 'agreement_marketing_all',
      name: 'agreement_marketing_all',
      value: 'marketingAll',
      label: t('partners.multisport.steps.step3.agreements.title'),
    }
  ))

  const checkboxesDetails = computed<ICheckbox[]>(() => [
    {
      id: 'agreement_rodo',
      name: 'objectAgreeRodo',
      value: AGREEMENT_KEYS.RODO,
      label: t('partners.multisport.steps.step3.agreements.rodo'),
    },
    {
      id: 'agreement_email',
      name: 'objectAgree',
      value: AGREEMENT_KEYS.EMAIL,
      label: t('partners.multisport.steps.step3.agreements.email'),
    },
    {
      id: 'agreement_tel',
      name: 'objectAgreeTelecommunications',
      value: AGREEMENT_KEYS.TEL,
      label: t('partners.multisport.steps.step3.agreements.tel'),
    },
    {
      id: 'agreement_partners',
      name: 'objectAgreeBenefit',
      value: AGREEMENT_KEYS.PARTNERS,
      label: t('partners.multisport.steps.step3.agreements.partners'),
    },
  ])

  const checkboxesTerms = computed<ICheckbox>(() => (
    {
      id: 'agreement_terms',
      name: 'agreement_terms',
      value: 'terms',
      label: t('partners.multisport.steps.step3.agreements.terms'),
    }
  ))

  function setAllAgreements(e: ICheckboxEvent) {
    form.objectAgree = !!e
    form.objectAgreeRodo = !!e
    form.objectAgreeTelecommunications = !!e
    form.objectAgreeBenefit = !!e
    form.objectAgreeMarketing = !!e
  }

  const allAgreementsSet = computed(() => {
    return [
      form.objectAgree,
      form.objectAgreeRodo,
      form.objectAgreeTelecommunications,
      form.objectAgreeBenefit,
    ].filter(value => !value).length === 0
  })

  return {
    checkboxesMain,
    checkboxesDetails,
    checkboxesTerms,
    allAgreementsSet,
    setAllAgreements,
  }
}
